/**
 * Retrieves a value from localStorage with expiry check
 * @param key - The localStorage key to retrieve
 * @returns The stored value if not expired, null otherwise
 */
export const getStorageWithExpiry = (key: string): string | null => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }

  try {
    const item = JSON.parse(itemStr);

    // If expiry is null, value never expires
    if (item.expiry === null) {
      return item.value;
    }

    const now = new Date();
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (error) {
    localStorage.removeItem(key);
    return null;
  }
};

/**
 * Stores a value in localStorage with an expiry time
 * @param key - The localStorage key to store the value under
 * @param value - The value to store
 * @param hours - Number of hours until the stored value expires, or null to never expire
 */
export const setStorageWithExpiry = (
  key: string,
  value: string,
  hours: number | null
): void => {
  const item = {
    value: value,
    expiry:
      hours === null ? null : new Date().getTime() + hours * 60 * 60 * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
};
